import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-home-search',
  templateUrl: './home-search.component.html',
  styleUrls: ['./home-search.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class HomeSearchComponent implements OnInit {
  constructor(private router: Router) {
    // Agrego esta linea para que Husky deje hacer commit y push.
  }

  ngOnInit(): void {
    // Agrego esta linea para que Husky deje hacer commit y push.
  }

  goToWellSearch(textWell: string): void {
    this.router.navigateByUrl('initiateHandover', {
      state: { textSearch: textWell },
    });
  }
}
